import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { WEB_APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

// product - Get All (Read)
export const GetAll = createAsyncThunk(
    "masters/product/get-all",
    async (filter, { rejectWithValue }) => {
        try {
            const res = await GET(
                `${WEB_APIS.Masters.Product}?name=${filter?.name || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}&stock_filter=${filter?.filter || ""}&sort_by=${filter?.sortBy || ""}`
            );
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// product - Get (Read)
export const GetSingle = createAsyncThunk(
    "masters/product/get",
    async (id, { rejectWithValue }) => {
        try {
            const res = await GET(`${WEB_APIS.Masters.Product}/${id}`);
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const GetproductTransactions = createAsyncThunk(
    "masters/product/get-ts",
    async ({ id, filter }, { rejectWithValue }) => {
        try {
            const res = await GET(`${WEB_APIS.Masters.Product}/transactions/${id}?name=${filter?.name || ""}&page=${filter?.page || IDS.PAGE
                }&per_page=${filter?.per_page || IDS.PERPAGE}&filter=${filter?.filter || ""}&sortBy=${filter?.sortBy || ""}`);
            return res?.data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// product - Create (Add)
export const Create = createAsyncThunk(
    "masters/product/create",
    async (data, { rejectWithValue }) => {
        try {
            const res = await POST(WEB_APIS.Masters.Product, data);

            if (res.success) {

                return res; // The new product object
            }

        } catch (error) {

            return rejectWithValue(error.response.data);
        }
    }
);

// product - Update
export const Update = createAsyncThunk(
    "masters/product/update",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const res = await PUT(`${WEB_APIS.Masters.Product}/${id}`, data);
            return res;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

// product - Delete
export const Delete = createAsyncThunk(
    "masters/product/delete",
    async (id, { rejectWithValue }) => {
        try {
            const data = await DELETE(`${WEB_APIS.Masters.Product}/${id}`);
            return id; // Return the id of the deleted product
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

// product - Status
export const Status = createAsyncThunk(
    "masters/product/status",
    async (id, { rejectWithValue }) => {
        try {
            const res = await POST(`${WEB_APIS.Masters.Product}/${id}`);
            return res;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const AddStock = createAsyncThunk(
    "masters/product/add-stock",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const res = await POST(`${WEB_APIS.Masters.Product}/add-stock/${id}`, data);
            return res;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);
export const ReduceStock = createAsyncThunk(
    "masters/product/reduce-stock",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            const res = await POST(`${WEB_APIS.Masters.Product}/reduce-stock/${id}`, data);
            return res;
        } catch (error) {
            return rejectWithValue(error.response.data);
        }
    }
);

export const Slice = createSlice({
    name: "product",
    initialState: {
        data: [],
        transactions: [],
        current_page: IDS.PAGE,
        total_pages: IDS.TOTALPAGES,
        per_page: IDS.PERPAGE,
        total: IDS.TOTAL,
        status: IDS.SLICESTATUS.Idle,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Handling all actions for GetSingle, Create, Update, Delete
            .addCase(GetAll.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetAll.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                state.data = action.payload?.data?.data || [];
                state.current_page = action.payload?.data?.current_page || IDS.PAGE;
                state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
                state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
                state.total = action.payload?.data?.total || IDS.TOTAL;
            })
            .addCase(GetAll.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(GetproductTransactions.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetproductTransactions.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                state.transactions = action.payload?.data || [];
                state.current_page = action.payload?.current_page || IDS.PAGE;
                state.total_pages = action.payload?.total_pages || IDS.TOTALPAGES;
                state.per_page = action.payload?.per_page || IDS.PERPAGE;
                state.total = action.payload?.total || IDS.TOTAL;
            })
            .addCase(GetproductTransactions.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(GetSingle.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(GetSingle.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
            })
            .addCase(GetSingle.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(Create.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(Create.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                // state.data = action.payload;
                state.data.unshift(action.payload.data);
            })
            .addCase(Create.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(Update.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(Update.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                // state.data = action.payload;
                const index = state.data.findIndex(
                    (product) => product.id === action.payload?.data?.id
                );
                if (index !== -1) {
                    state.data[index] = action.payload.data;
                }
            })
            .addCase(Update.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })

            .addCase(Delete.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(Delete.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                // state.data = action.payload;
                state.data = state.data.filter(
                    (product) => product.id !== action.payload.id
                ); // Remove the product with the deleted id
            })
            .addCase(Delete.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            })
            //
            .addCase(Status.pending, (state) => {
                state.status = IDS.SLICESTATUS.Loading;
            })
            .addCase(Status.fulfilled, (state, action) => {
                state.status = IDS.SLICESTATUS.Succeeded;
                // state.data = action.payload;
                state.data = state.data.filter(
                    (product) => product.id !== action.payload.id
                ); // Remove the product with the deleted id
            })
            .addCase(Status.rejected, (state, action) => {
                state.status = IDS.SLICESTATUS.Failed;
                state.error = action.payload;
            });
    },
});

// Export actions (if needed in components)
export const { } = Slice.actions;

export default Slice.reducer;
